// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1adWB","name":"Header_name__1QG01","birthday":"Header_birthday__1DB4u","skeleton":"Header_skeleton__15nvG"};